<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="report d-flex flex-column">
			<div class="d-flex justify-content-between">
				<div class="heading headtext">
					Individual Test Report for '{{ testDetails.name }}'
				</div>
				<div>
					<b-button class="addbtn" @click="exportexcel()"
						>Export Excel</b-button
					>
				</div>
			</div>
			<b-row class="p-4 report__card">
				<b-col>
					<b-row class="details-row my-4">
						<b-col class="details">
							<span class="details-prop">Name</span>
							<span
								class="details-val"
								v-b-popover.hover.top="testDetails.name"
								>{{ testDetails.name | topicNameFilter }}</span
							>
						</b-col>
						<b-col class="details">
							<span class="details-prop">Topic</span>
							<span
								class="details-val"
								v-b-popover.hover.top="testDetails.topicName"
								>{{ testDetails.topicName | topicNameFilter }}</span
							>
						</b-col>
						<b-col class="details">
							<span class="details-prop">Difficulty</span>
							<span class="details-val">{{
								testDetails.averageDifficulty
							}}</span>
						</b-col>
						<b-col class="details">
							<span class="details-prop">Created At</span>
							<span class="details-val">
								{{ testDetails.createdAt | datefilter }}
								at
								{{ testDetails.createdAt | timefilter }}
							</span>
						</b-col>
					</b-row>
					<b-row class="details-row w-50 my-4">
						<b-col class="details">
							<span class="details-prop">Total Marks</span>
							<span class="bluenumbertext">{{ testDetails.totalMarks }}</span>
						</b-col>
						<b-col class="details">
							<span class="details-prop">Total Sections</span>
							<span class="yellownumbertext">{{
								testDetails.totalSections
							}}</span>
						</b-col>
						<b-col class="details">
							<span class="details-prop">Total Candidates</span>
							<span class="pinknumbertext">{{
								testDetails.totalCandidates
							}}</span>
						</b-col>
					</b-row>
				</b-col>
				<b-col cols="4">
					<b-row
						class="card-template"
						v-for="(value, property, index) in this.testStatistics"
						:key="index"
						:style="{ borderLeft: '5px solid ' + color[index] }"
					>
						<b-col class="card-prop">
							<span v-if="property == 'mean'">Mean</span>
							<span v-if="property == 'maximumScore'">Maximum Score</span>
							<span v-if="property == 'median'">Median</span>
							<span v-if="property == 'minimumScore'">Minimum Score</span>
						</b-col>
						<b-col class="card-val" :style="{ color: color[index] }">{{
							value
						}}</b-col>
					</b-row>
				</b-col>
			</b-row>
			<b-row class="report__card">
				<div class="d-flex w-100">
					<b-col>
						<PieChart url="difficulty" :testId="testId" />
					</b-col>
					<b-col cols="0" class="divider"></b-col>
					<b-col>
						<PieChart url="section" :testId="testId" />
					</b-col>
				</div>
			</b-row>
			<b-row>
				<b-col class="report__card" v-if="candidateTableData.length > 0">
					<Histogram url="/marks-distribution" title="Marks Distribution" />
				</b-col>
				<b-col>
					<div class="overflow-auto my-3 p-2" style="height: 55vh">
						<div
							class="pd-cards pointer mt-3 position-relative"
							v-for="candidate in candidateTableData"
							:key="candidate.candidateID"
							:title="
								candidate.candidateScore
									? 'Click to view candidate performance'
									: `${candidate.candidateID}'s scores haven't been marked yet`
							"
							@click="
								handleCandidateCardClick(
									candidate.candidateID,
									candidate.candidateScore,
									candidate
								)
							"
						>
							<div class="relativeclass tp-gridcont">
								<div
									:style="{
										background:
											'#' +
											Math.random()
												.toString(16)
												.substr(-6),
									}"
									class="gridgreencolorDynamic"
								></div>
								<div class="d-flex flex-column ml-2" style="width: 30%">
									<div class="pd-card-middle-head">Name:</div>
									<div class="tp-text pd-card-test-head">
										{{ candidate.name }}
									</div>
								</div>
								<div
									class="d-flex flex-column"
									style="width: 15%; border-right: solid 0.3px lightgrey"
								>
									<span class="pd-card-middle-head">Total Marks</span>
									<span class="bluenumbertext">{{
										candidate.candidateScore || "Unmarked"
									}}</span>
								</div>
								<div
									class="scroll-card d-flex overflow-auto position-absolute"
									style="width: 50%; left: 50%"
								>
									<!-- Run a loop to display candidate performance in that test -->
									<div
										v-for="(section, index) in candidate.sectionScores"
										:key="index"
										class="d-flex flex-column flex-shrink-0"
										style="width: 32%"
									>
										<div class="d-flex">
											<div
												class="pd-card-middle-head"
												v-b-popover.hover.top="candidate.name"
											>
												{{ section.name | topicNameFilter }}
											</div>
										</div>
										<div class="section-marks-reports">
											<div :key="index" :style="{ color: color[index] }">
												{{ section.markScored }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="pd-cards" v-if="candidateTableData.length == 0">
							<div>No candidates have taken this test</div>
						</div>
					</div>
				</b-col>
				<!-- Pie Charts for difficulty and section wise question distribution -->
			</b-row>
		</div>
	</div>
</template>

<script>
import PieChart from "./PieChart.vue";
import Histogram from "./Histogram.vue";
import {
	getTestInformation,
	getTestStats,
	getCandidateScoreDetails,
	downloadExcel,
} from "../../../utils/apiFunctions";
import Spinner from "../../../components/fixedcomponents/Spinner.vue";

export default {
	name: "IndividualTest",
	components: {
		PieChart,
		Histogram,
		Spinner,
	},
	data() {
		return {
			color: ["#4EF085", "#F2BB89", "#89EBF2", "#1a4164"],
			testId: this.$route.params.testID,
			topicId: this.$route.params.topicID,
			sortBy: "slNo",
			sortDesc: false,
			testDetails: {},
			LoaderStatus: false,
			testStatistics: {
				Average: "N/A",
				Median: "N/A",
				Range: "N/A",
			},
			// The table fields need to be in proper case for vue-bootstrap to render properly
			candidateTableFields: [
				{ key: "slNo", sortable: true },
				{ key: "name", sortable: true },
				{ key: "section1", sortable: true },
				{ key: "section2", sortable: true },
				{ key: "section3", sortable: true },
				{ key: "totalMarks", sortable: true },
			],
			candidateTableData: [],
		};
	},

	// async mounted() {
	//   try {

	//   } catch (e) {
	//     console.error("Error getting data", e);
	//   }
	// },
	created() {
		this.LoaderStatus = true;
		this.getTestInformation();
		this.getCandidateDetails();
		this.getTestStatsDetails();
		setTimeout(() => {
			this.LoaderStatus = false;
		}, 1000);
	},
	computed: {
		cssForDynamicColor() {
			return {
				"--dynamicBorderColor":
					"#" + ((Math.random() * 0xffffff) << 0).toString(16),
			};
		},
	},
	methods: {
		handleCandidateCardClick(candidateId, candidateScore, candidate) {
			if (!candidateScore) return;
			this.$router.push({
				path: `/reports/candidate/${this.testId}/${candidateId}/${candidate.name}`,
			});
		},
		async getTestInformation() {
			const res1 = await getTestInformation(this.topicId, this.testId);

			if (res1.status == 200) {
				this.testDetails = res1.data.data;
			}
		},
		async getCandidateDetails() {
			const res1 = await getCandidateScoreDetails(this.testId);

			if (res1.status == 200) {
				this.candidateTableData = res1.data.data;
			}
		},
		async getTestStatsDetails() {
			const res1 = await getTestStats(this.testId);

			if (res1.status == 200) {
				this.testStatistics = res1.data.data;
			}
		},
		async exportexcel() {
			const res = await downloadExcel(this.testId);
			window.open(res.data.data.S3link);
		},
		async getData() {
			const values = await Promise.all([
				getTestInformation(this.topicId, this.testId),
				getTestStats(this.testId),
				getCandidateScoreDetails(this.testId),
			]);
			values.forEach((data) => {
				if (data.data.type !== "Success") {
					throw new Error("Request Failed");
				}
			});

			// Processing testStats or values[1]
			const statRes = values[1].data.data;
			const testsStats = {
				Average: statRes.mean,
				Median: statRes.median,
				Range:
					statRes.maximumScore === "N/A" || statRes.minimumScore === "N/A"
						? "N/A"
						: `${statRes.minimumScore} - ${statRes.maximumScore}`,
			};

			return {
				testDetails: values[0].data.data,
				testStatistics: testsStats,
				candidateTableData: values[2].data.data,
			};
		},
	},
};
</script>

<style scoped>
.divider {
	width: 0;
	border: solid 1px #00000033;
}

.gridgreencolorDynamic {
	width: 4px;
	height: 60px;
	border-radius: 2px;
	position: absolute;
	left: -5px;
	top: -8px;
}

.report {
	position: relative;
	top: 80px;
	padding-left: 80px;
	padding-right: 15px;
	margin-bottom: 10rem;
}

.card-template {
	background: var(--bg-white);
	border: 0.5px solid rgba(114, 115, 142, 0.3);
	border-radius: 1px;
	padding: 15px;
	margin: 0.5rem auto;
}

.card-prop {
	font-size: var(--size-14);
	color: #696969;
	font-weight: 400;
}

.card-val {
	font-size: var(--size-14);
	font-weight: 500;
}

.details {
	display: flex;
	flex-direction: column;
}

.details-prop {
	font-size: 13px;
	color: #72738e;
	margin-bottom: 7px;
}

.details-val {
	font-weight: 500;
	color: #72738e;
}

.report__card {
	display: flex;
	justify-content: center;
	align-items: center;
	background: var(--bg-white);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 15px;
	margin: 1rem;
}

.report__test-details {
	width: 80%;
}

.placeholder {
	height: 300px;
}

.scroll-card {
	-ms-overflow-style: none;
	scrollbar-width: none;
}

.charts ::-webkit-scrollbar {
	display: none;
}

tr {
	cursor: pointer;
}

.section-marks-reports {
	font-weight: 500;
	font-size: 14px;
}
</style>
